// Palette e stili condivisi dalle pagine V2: i neutri seguono il tema (chiaro/scuro) tramite variabili CSS,
// definite in theme/tokens.js. Il verde del brand e i colori dei grafici sono uguali nei due temi.
import { useTheme } from '@mui/material/styles';
import { TOKENS, v } from '../../theme/tokens';

export const INK = v('ink');
export const MUTED = v('muted');
export const LINE = v('line');
export const GREEN = '#5ab031';
export const GREEN_DARK = v('green-dark');
export const GREEN_SOFT = v('green-soft');

// Colori dei giorni, coerenti con la vista People Manager
export const DAY_COLORS = {
  ok: GREEN,
  partial: '#E8B931',
  under: '#EF7A1A',
  missing: '#E04844',
  absence: '#C9CFC6',
  weekend: '#C9CFC6',
  today: GREEN,
  future: '#9CC3F2',
};

// Serie per la ripartizione del tempo (ordine di comparsa)
export const SERIES = ['#5ab031', '#2A9D8F', '#3B82F6', '#E9A23B', '#8E6BBF', '#E36D8C', '#7A8A99'];

export const cardSx = {
  bgcolor: v('paper'),
  border: `1px solid ${LINE}`,
  borderRadius: 4,
  p: { xs: 2, md: 2.5 },
  height: '100%',
  boxSizing: 'border-box',
};

export const cardTitleSx = { fontSize: 15, fontWeight: 700, color: INK };
export const captionSx = { fontSize: 12.5, color: MUTED };

/** Colori del tema attuale come valori (per gli attributi SVG dei grafici, dove le variabili CSS non valgono). */
export function useThemeColors() {
  const theme = useTheme();
  return TOKENS[theme.rtVariant || theme.palette.mode] || TOKENS.light;
}
